import { AuthStateHook, useAuthState } from 'react-firebase-hooks/auth';
import { getAuth } from 'firebase/auth';
import { useFirebaseApp } from './useFirebaseApp';

export const useUser = (): AuthStateHook => {
	const firebaseApp = useFirebaseApp();
	const auth = getAuth(firebaseApp);
	return useAuthState(auth);
};
